/* hzo-reviews.js — de vakjes, de lange teksten en het schrijfblad.
 *
 * WAT DIT BESTAND NIET DOET: rekenen of ophalen. Alle beoordelingen staan al in
 * de HTML, door Liquid gerenderd. Dit script verbergt en toont er vijf. Zou het
 * ze ophalen, dan zag Google ze niet en had een trage verbinding een leeg blok.
 */
(() => {
  if (window.__hzoReviews) return;
  window.__hzoReviews = true;

  /* ── vijf per vakje ────────────────────────────────────────────────────── */
  function toon(sectie, vak) {
    const per = Number(sectie.dataset.perVakje || 5);
    const alle = [...sectie.querySelectorAll('[data-hzo-brev]')];

    /* Bij "all" de nieuwste, anders die van het onderwerp — ook op datum, want
       een vakje dat met de oudste begint leest als een dood blok. */
    const passend = alle
      .filter((b) => vak === 'all' || b.dataset.onderwerp === vak)
      .sort((a, b) => Number(a.dataset.dagen) - Number(b.dataset.dagen));

    const zichtbaar = passend.slice(0, per);
    alle.forEach((b) => {
      b.hidden = !zichtbaar.includes(b);
    });

    /* Een leeg vakje verdwijnt niet, er komt een regel te staan. Weghalen leest
       als iets verbergen. */
    const leeg = sectie.querySelector('[data-hzo-rev-leegvak]');
    if (leeg) leeg.hidden = zichtbaar.length > 0;

    sectie.querySelectorAll('[data-hzo-vak]').forEach((k) => {
      const aan = k.dataset.hzoVak === vak;
      k.classList.toggle('is-aan', aan);
      k.setAttribute('aria-selected', String(aan));
    });
  }

  document.addEventListener('click', (e) => {
    const vak = e.target.closest?.('[data-hzo-vak]');
    if (vak) {
      const sectie = vak.closest('[data-hzo-reviews]');
      if (sectie) toon(sectie, vak.dataset.hzoVak);
      return;
    }

    /* ── het schrijfblad ── */
    if (e.target.closest?.('[data-hzo-rev-open]')) {
      e.preventDefault();
      openBlad();
      return;
    }
    if (e.target.closest?.('[data-hzo-rev-sluit]')) {
      e.preventDefault();
      const d = document.querySelector('[data-hzo-revform]');
      d?.close();
      /* terugzetten op het formulier: anders zie je de tweede keer meteen de
         bedankstand en lijkt het blad stuk */
      const form = d?.querySelector('[data-hzo-revform-form]');
      if (form) {
        form.querySelector('[data-hzo-revform-velden]').hidden = false;
        form.querySelector('[data-hzo-dank]').hidden = true;
      }
    }
  });

  function openBlad() {
    const d = document.querySelector('[data-hzo-revform]');
    if (!d) return;
    if (typeof d.showModal === 'function') d.showModal();
    else d.setAttribute('open', '');
  }

  /* Naast het blad klikken sluit het. De klik landt dan op het venster zelf en
     niet op het witte vlak erin. */
  document.addEventListener('click', (e) => {
    const d = e.target.closest?.('[data-hzo-revform]');
    if (d && e.target === d) d.close();
  });

  /* ── de knop pas aan als er een score staat ────────────────────────────── */
  document.addEventListener('change', (e) => {
    if (!e.target.matches?.('input[name="contact[Rating]"]')) return;
    const form = e.target.closest('form');
    form?.querySelector('[data-hzo-rev-versturen]')?.removeAttribute('disabled');
    const veld = form?.querySelector('[data-hzo-veld-score]');
    veld?.classList.remove('is-fout');
    const fout = veld?.querySelector('[data-hzo-fout]');
    if (fout) fout.hidden = true;
  });

  /* ── versturen ────────────────────────────────────────────────────────────
     ER GAAT NIETS DE DEUR UIT. Het formulier heeft geen bestemming: we vangen
     het versturen af en wisselen naar de bedankstand. Zo kun je alle standen
     doorklikken zonder dat er een mail vertrekt en zonder herladen.

     De controle op de score staat hier en niet op het `required`-kenmerk: dan
     neemt de browser het over met zijn eigen ballon en zie je onze melding
     nooit. */
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches?.('[data-hzo-revform-form]')) return;
    e.preventDefault();

    const veld = form.querySelector('[data-hzo-veld-score]');
    const fout = veld?.querySelector('[data-hzo-fout]');
    if (!form.querySelector('input[name="contact[Rating]"]:checked')) {
      veld?.classList.add('is-fout');
      if (fout) fout.hidden = false;
      veld?.scrollIntoView({ block: 'center' });
      return;
    }

    /* de rest is gewoon HTML-validatie; die melding van de browser is prima */
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    form.querySelector('[data-hzo-revform-velden]').hidden = true;
    form.querySelector('[data-hzo-dank]').hidden = false;
    form.closest('[data-hzo-revform]')?.scrollTo({ top: 0 });
  });

  /* ── bij het laden ─────────────────────────────────────────────────────── */
  function start() {
    document.querySelectorAll('[data-hzo-reviews]').forEach((sectie) => {
      /* GEEN AFKAPPEN MEER. Er stond een Read more onder elke tekst boven de
         honderdtwintig tekens, maar in de praktijk scheelde dat een paar woorden:
         een extra knop om drie woorden te verbergen is meer werk voor de lezer
         dan die drie woorden zelf. De hele tekst staat er nu gewoon. */
      toon(sectie, 'all');
    });

    /* Het blad opent leeg. Er is niets om te herstellen na een herlaadbeurt,
       want er wordt niets verstuurd. */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
